import { useMemo } from "react";

import { PURCHASE_TYPES } from "@utils/index";
import {
  AssetType,
  DropdownItemModel,
  AssetPurchaseType,
} from "@interfaces/index";
import { Dropdown } from "@components/index";

export const AssetPurchaseTypeSelector = ({
  type = "",
  value = "",
  onSetAssetPurchaseType,
  error,
  dataTestid,
}: {
  type: AssetType | "";
  value?: string;
  onSetAssetPurchaseType?: (assetPurchaseType: string) => void;
  error?: string;
  dataTestid?: string;
}) => {
  const purchaseTypes: DropdownItemModel[] = useMemo(() => {
    const allPurchaseTypes = Object.keys(PURCHASE_TYPES).map((key) => ({
      id: key,
      title: PURCHASE_TYPES[key as AssetPurchaseType],
    }));
    switch (type) {
      case "rental_property":
        return allPurchaseTypes.filter(({ id }) =>
          ["purchased_outright", "mortgage", "lease", "loan"].includes(id),
        );
      case "vehicle":
        return allPurchaseTypes.filter(({ id }) =>
          [
            "purchased_outright",
            "hire_purchase",
            "personal_contract_purchase",
            "loan",
            "lease",
          ].includes(id),
        );
      case "other":
        return allPurchaseTypes.filter(({ id }) =>
          ["purchased_outright", "finance"].includes(id),
        );
      default:
        return [];
    }
  }, [type]);

  const handleSelectAssetPurchaseType = (id: string) => {
    if (onSetAssetPurchaseType) {
      onSetAssetPurchaseType(id);
    }
  };

  return (
    <Dropdown
      items={purchaseTypes}
      showClearButton
      label="Purchase Type"
      value={value}
      onSelect={handleSelectAssetPurchaseType}
      error={error}
      dataTestid={dataTestid}
    />
  );
};
